import React from 'react'
import { FormField, FormGroup, Radio } from 'semantic-ui-react'

import PermissionCheckboxGroup from 'components/PermissionCheckboxGroup/container'
import EmptyState from 'shared/components/EmptyState'
import { NewTabLink } from 'components/NewTabLink'

export default function VisibilityPermissionForm({
  setting,
  handlePermissionChange,
  surveyAccesses,
  isEnabledSurveyAccess,
  isEnabledDashboardAccess,
  dashbardAccesses,
  actions,
  isFetchingSurveys,
  isFetchingDashboards,
  isDisabled,
  isDefaultCollaborator,
}: VisibilityPermissionFormProps) {
  function deselectAndMutedAllActions() {
    actions.forEach((action) => {
      handlePermissionChange(['permissions', action.name], false)
    })
  }
  const isFeedbackPermissionAndCollaborator =
    setting.name === 'view_feedback' && isDefaultCollaborator
  const isDisabledButton = isFeedbackPermissionAndCollaborator ? false : isDisabled

  return (
    <React.Fragment>
      <FormGroup grouped>
        <label>Visibility</label>
        <p>{setting.description}</p>
        {setting.options.map((option) => (
          <FormField
            key={option.key}
            control={Radio}
            label={option.text}
            value={option.value}
            checked={setting.value === option.value}
            disabled={isDisabledButton}
            onChange={(_, { value }) => {
              handlePermissionChange(['permissions', setting.name], value)
              if (value === 'no_access') {
                deselectAndMutedAllActions()
              }
            }}
          />
        ))}
      </FormGroup>
      {isEnabledSurveyAccess && (
        <PermissionCheckboxGroup
          defaultPermissionAccesses={surveyAccesses}
          onChange={(surveyAccess) => {
            handlePermissionChange(['survey_access'], surveyAccess)
          }}
          loading={isFetchingSurveys}
          hasError={false}
          noDataMessage={
            <EmptyState
              icon={<i className="far fa-poll-h" />}
              callToAction={
                <NewTabLink to="/settings/surveys/?create=true">Create a new survey.</NewTabLink>
              }
            >
              Your account doesn't have any surveys yet.
            </EmptyState>
          }
          searchText="Search surveys"
        />
      )}
      {isEnabledDashboardAccess && (
        <PermissionCheckboxGroup
          defaultPermissionAccesses={dashbardAccesses}
          onChange={(dashboardAccess) => {
            handlePermissionChange(['dashboard_access'], dashboardAccess)
          }}
          loading={isFetchingDashboards}
          hasError={false}
          noDataMessage={
            <EmptyState
              icon={<i className="far fa-poll-h" />}
              callToAction={<NewTabLink to="/">Create a new custom dashboards.</NewTabLink>}
            >
              Your account doesn't have any custom dashboards yet.
            </EmptyState>
          }
          searchText="Search custom dashboards"
        />
      )}
    </React.Fragment>
  )
}

interface VisibilityPermissionFormProps {
  setting: {
    name: string
    description: string
    value: string
    options: {
      key: string
      text: string
      value: string
    }[]
  }
  handlePermissionChange: (path: string[], value: any) => void
  surveyAccesses: any
  isEnabledSurveyAccess: boolean
  actions: {
    name: string
    label: string
    value: boolean
  }[]
  isEnabledDashboardAccess: boolean
  dashbardAccesses: any
  isFetchingSurveys?: boolean
  isFetchingDashboards?: boolean
  isDisabled: boolean
  isDefaultCollaborator: boolean
}



// WEBPACK FOOTER //
// ./src/components/CustomRoleForm/components/VisibilityPermissionForm.tsx